var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "transfer mmqr" },
    [
      _c("popup", {
        staticClass: "popup",
        attrs: { opened: _vm.openData, "use-header": true, "use-footer": true },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          },
          cancel: _vm.popupClose
        },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function() {
              return [
                _c("h2", [
                  _vm._v(
                    _vm._s(/*MMQR 결제상세정보*/ _vm.$t("MPAY-07-01-01-11"))
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "dl",
                  { staticClass: "dlist dlist-item--type6" },
                  [
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*거래 신청일시*/ _vm.$t("MPAY-07-01-01-15"))
                      )
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$getGlobalDateFmt(
                            _vm._.padEnd(_vm.detailInfo.pyaccYMS, 20, " ")
                          )
                        )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*처리 상태*/ _vm.$t("MPAY-07-01-01-19")))
                    ]),
                    _vm.detailInfo.tranPrgrsDsticName == "Failed" ||
                    _vm.detailInfo.tranPrgrsDsticName == "(Refund)Failed" ||
                    _vm.detailInfo.tranPrgrsDsticName == "Error"
                      ? _c("dd", { staticClass: "right warning" }, [
                          _vm._v(_vm._s(_vm.detailInfo.tranPrgrsDsticName))
                        ])
                      : _c("dd", { staticClass: "right normal" }, [
                          _vm._v(_vm._s(_vm.detailInfo.tranPrgrsDsticName))
                        ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*결제방법*/ _vm.$t("MPAY-07-01-01-14")))
                    ]),
                    "1|3|4|9".includes(_vm.detailInfo.tranPrgrsDstcd)
                      ? _c("dd", { staticClass: "right" }, [
                          _vm._v(_vm._s(_vm.$t("MPAY-07-01-01-60")))
                        ])
                      : _c("dd", { staticClass: "right" }, [
                          _vm._v(_vm._s(_vm.$t("MPAY-07-01-01-64")))
                        ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*계좌번호*/ _vm.$t("MPAY-07-01-01-18")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(
                        _vm._s(_vm.$maskAccNoByMMQR(_vm.detailInfo.drwotAcno))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*거래 ID*/ _vm.$t("MPAY-07-01-01-13")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.tranID))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*MMQR 레퍼런스 ID*/ _vm.$t("MPAY-07-01-01-04"))
                      )
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.refID))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*판매자 계좌번호*/ _vm.$t("MPAY-07-01-01-22"))
                      )
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(
                        _vm._s(_vm.$maskAccNoByMMQR(_vm.detailInfo.mnrcvAcno))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*판매자*/ _vm.$t("MPAY-07-01-01-21")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.draweName))
                    ]),
                    "5|6|7".includes(_vm.detailInfo.tranPrgrsDstcd)
                      ? [
                          _c("dt", [
                            _vm._v(_vm._s(/*원금*/ _vm.$t("MPAY-07-01-01-65")))
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _c("span", { staticClass: "exchange-unit" }, [
                              _vm._v(_vm._s(_vm.detailInfo.cncycd))
                            ]),
                            _c("span", { staticClass: "amount" }, [
                              _vm._v(
                                _vm._s(_vm.$num(_vm.detailInfo.orgTranAmt))
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _c("dt", [
                      _vm._v(_vm._s(/*금액*/ _vm.$t("MPAY-07-01-01-24")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _c("span", { staticClass: "exchange-unit" }, [
                        _vm._v(_vm._s(_vm.detailInfo.cncycd))
                      ]),
                      _c("span", { staticClass: "amount" }, [
                        _vm._v(_vm._s(_vm.$num(_vm.detailInfo.pyaccAmt)))
                      ])
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수수료*/ _vm.$t("MPAY-07-01-01-23")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _c("span", { staticClass: "exchange-unit" }, [
                        _vm._v(_vm._s(_vm.detailInfo.cncycd))
                      ]),
                      _c("span", { staticClass: "amount" }, [
                        _vm._v(_vm._s(_vm.$num(_vm.detailInfo.fee)))
                      ])
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*메모*/ _vm.$t("MPAY-07-01-01-25")))
                    ]),
                    _c("dd", { staticClass: "right align-right" }, [
                      _vm._v(
                        _vm._s(
                          "5|6|7".includes(_vm.detailInfo.tranPrgrsDstcd)
                            ? _vm.$t("217_입출근거적요코드")
                            : _vm.detailInfo.draweRefCtnt
                        )
                      )
                    ]),
                    _vm.detailInfo.qrDstcd == 1
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/*참조 번호*/ _vm.$t("MPAY-07-01-01-08"))
                            )
                          ]),
                          _c("dd", { staticClass: "right anywhere" }, [
                            _vm._v(_vm._s(_vm.detailInfo.refNo))
                          ]),
                          _c("dt", [
                            _vm._v(
                              _vm._s(/*청구서 번호*/ _vm.$t("MPAY-07-01-01-09"))
                            )
                          ]),
                          _c("dd", { staticClass: "right anywhere" }, [
                            _vm._v(_vm._s(_vm.detailInfo.billNo))
                          ]),
                          _c("dt", [
                            _vm._v(_vm._s(/*목적*/ _vm.$t("MPAY-07-01-01-26")))
                          ]),
                          _c("dd", { staticClass: "right anywhere" }, [
                            _vm._v(_vm._s(_vm.detailInfo.tranPurpose))
                          ])
                        ]
                      : _vm._e(),
                    "4|6".includes(_vm.detailInfo.tranPrgrsDstcd)
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/*거절 사유*/ _vm.$t("MPAY-07-01-01-16"))
                            )
                          ]),
                          _c(
                            "dd",
                            { staticClass: "right align-right anywhere" },
                            [_vm._v(_vm._s(_vm.detailInfo.rejcnResn))]
                          )
                        ]
                      : _vm._e(),
                    "5|6|7".includes(_vm.detailInfo.tranPrgrsDstcd)
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/*환불 사유*/ _vm.$t("MPAY-07-01-01-17"))
                            )
                          ]),
                          _c(
                            "dd",
                            { staticClass: "right align-right anywhere" },
                            [_vm._v(_vm._s(_vm.detailInfo.refndResn))]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _c("div", { staticClass: "align-center mtop-24 mbtm-24" }, [
                  _c("i", { staticClass: "icon img-mmqr-logo" }),
                  _c("span", { staticClass: "v-hidden" }, [
                    _vm._v("MyanmarPay "),
                    _c("em", [_vm._v("MMQR")])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        return _vm.popupClose()
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*뒤로*/ _vm.$t("MPAY-07-01-01-59")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }